module.exports = __webpack_public_path__ + "static/img/yuda.74d26cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./image/yuda.jpg
// module id = TbJv
// module chunks = 29